export const env = {
    API_ENDPOINT: process.env.REACT_APP_API_URL || "",
    GEOAPIFY_API_KEY:
        process.env.REACT_APP_GEOAPIFY_API_KEY ||
        "2401e90a0a52463c90ea05e0356a83fe",
};
